// Allergies
export const ROOM_LIST_LOADED = 'ROOM_LIST_LOADED'
export const roomListLoaded = (rooms) => ({
  type: ROOM_LIST_LOADED,
  rooms,
})
export const CLEAR_ROOM_LIST = 'CLEAR_ROOM_LIST'
export const clearRoomList = () => ({
  type: CLEAR_ROOM_LIST,
})

export const getNextRoomId = (state, roomId) => state.adminRooms[state.adminRooms.indexOf(roomId) + 1]
export const getPreviousRoomId = (state, roomId) => state.adminRooms[state.adminRooms.indexOf(roomId) - 1]

const initialState = []
export const adminRoomsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ROOM_LIST_LOADED:
      return action.rooms.map((room) => room.id)
    default:
      return state
  }
}
